import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";

function PageSecondLayout({
  title,
  descriptionOne,
  descriptionTwo,
  imgsrc1,
  imgsrc2,
  imgsrc3,
}) {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);

  const images = [imgsrc1, imgsrc2, imgsrc3];

  return (
    <Container>
      <Right data-aos="fade-left">
        <div className="container">
          {images.map((src, index) => (
            <div className="card" key={index}>
              <img src={src} alt={`Card ${index}`} />
            </div>
          ))}
        </div>
      </Right>
      <Left data-aos="fade-right">
        <h1 className="shine">{title}</h1>
        <p>{descriptionOne}</p>
        <br />
        <p>{descriptionTwo}</p>
      </Left>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const Left = styled.div`
  width: 55%;
  height: 100%;
  padding: 30px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media only screen and (max-width: 1200px) {
    width: 100%;
    padding: 10px;
    text-align: center;
  }

  h1 {
    font-size: 2rem;
    margin: 10px 0 20px 0;
    text-transform: uppercase;

    @media only screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  p {
    line-height: 1.5rem;
    font-size: 1rem;

    @media only screen and (max-width: 768px) {
      font-size: 0.9rem;
      text-align: center;
    }
  }
`;

const Right = styled.div`
  width: 45%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    width: 60%;
  }

  @media only screen and (max-width: 768px) {
    width: 90vw;

    .container {
      width: 95%;
      margin-bottom: 5vh;
      margin-top: 2vh;
    }
  }

  .card {
    background-color: #fff;
    height: 50vh;
    width: 10vw;
    flex: 1;
    border-radius: 16px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    @media only screen and (max-width: 1200px) {
      width: 100%;
      height: 220px;
      .container {
        width: 95%;
      }
    }

    @media only screen and (max-width: 768px) {
      width: 75%;
      height: 220px;
      .container {
        width: 95%;
        margin-bottom: 5vh;
        margin-top: 2vh;
      }
    }

    @media only screen and (max-width: 480px) {
      width: 100%;
      height: 220px;
      .container {
        width: 95%;
        margin-bottom: 5vh;
        margin-top: 2vh;
      }
    }
  }

  .card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;

    @media only screen and (max-width: 768px) {
      height: 100%;
    }
  }

  .card:hover {
    flex: 2;
    background-color: #b8b8b8;
  }
`;

export default PageSecondLayout;
